<div [@routerTransition] [style.marginTop.px]="marginTop">
  <div class="row">

    <div class="columnbv4">
      <div class="border-right2 padding-right-5px height-100pe">
        <div class="card height-100pe">

          <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
            <div class="row margin-top10px margin-left-20px  nav-link-hand">
              <div class="col-md-4 padding-left-0px">
                <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                  PP Bills
                </label>
              </div>

              <div (click)="DecrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                <a title="Previous" class="nav-link-hand">
                  <i class="fas fa-caret-left margin-top-3px font-size-24px"></i>
                </a>
              </div>
              <div class="col-md-4 col-sm-4 padding-left-5px padding-right-9px">
                <div class="date-form billing-calender">
                  <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px  data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                         name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                         (ngModelChange)="dataChanged($event)">

                  <a (click)="d.toggle()" class="nav-link-hand">
                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                  </a>

                </div>



              </div>
              <div (click)="IncrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                <a title="Next" class="nav-link-hand">
                  <i class="fas fa-caret-right margin-top-3px font-size-24px"></i>
                </a>
              </div>

              <div *canUserAccess="['HL_BL_29']">
                <div *ngIf="FromScreen == 'NONE'" class="col-md-1">
                  <button type="button" class="btn  btn-sm button-new-health2" (click)="Addopbill()" tooltip="Add" *canUserAccess="['HL_BL_3']"><i class="fas fa-plus nav-link-hand"></i></button>

                </div>
              </div>
              <div *canUserAccess="['HL_BL_30']">
              <div *ngIf="FromScreen == 'NONE'" class="col-md-1">
                <button type="button" class="btn  btn-sm button-new-health-red" (click)="Addopbill_withServiceProvider()" tooltip="Add" *canUserAccess="['HL_BL_3']"><i class="fas fa-plus nav-link-hand"></i></button>

              </div>
            </div> 


              <div *ngIf="FromScreen == 'CommonBilling'" class="col-md-1">
                <button type="button" class="btn  btn-sm button-new-health2" (click)="Addcommonbill()" tooltip="Add" *canUserAccess="['HL_BL_3']"><i class="fas fa-plus nav-link-hand"></i></button>

              </div>
            </div>
          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
            <div class="row margin-right-0px margin-left-0px">
              <div class="col-md-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

              </div>              
              <div class="col-md-2" hidden>
                <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
              </div>
              <div class="col-md-1 padding-left-8px" hidden>
                <a class="nav-link-hand education-navlink" tooltip="Edit">
                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                </a>

              </div>
              <div class="col-md-1 padding-left-8px" hidden>
                <a class="nav-link-hand education-navlink" tooltip="Delete">
                  <span class="badge font-size-14">
                    <i class="far fa-trash-alt"></i>
                  </span>
                </a>
              </div>

            </div>
            <div>
              <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps overflow-x-hidden padding-lrt " data-ps-id="dfsfsde">
                <div *ngIf="isRequesting">

                  <div class="loader-text">
                    <div class="loader-text2">

                      <div class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <div class="margin-top-20px margin-left-5px">
                        <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                      </div>

                    </div>
                  </div>


                </div>
                <div *ngIf="!isRequesting">
                  <div class="row border-bottom row-for-scans2 margin-left16px nav-link-hand padding-bottom-6px" (click)="Selectedpatient(l)" *ngFor="let l of pdata">
                    <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient(l)">
                      <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.PatientImageFile" onError="this.src='dummy.jpg';">



                    </div>
                    <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.ReceiptFormattedCode}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.PatientName}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.PatientFormattedCode}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4">
                          <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.PatientTelephoneNumber1}}</label>
                        </div>

                      </div>

                    </div>
                    <div class="col-md-3 padding-left-0px margin-top-5px">
                      <div class="text-align-center">

                        <!--<a data-toggle="tooltip" data-placement="bottom" title="Completed" *ngIf="l.ActivityStatus=='Completed'">

                          <i class="fas fa-check-circle color-icon-completed font-size-16px">
                          </i>
                        </a>
                        <a data-toggle="tooltip" data-placement="bottom" title="Initiated" *ngIf="l.ActivityStatus=='Initiated'">

                          <i class="fas fa-check-circle color-gray font-size-16px">
                          </i>
                        </a>-->
                        <!--<i class="fas fa-check-circle color-icon-completed "></i>-->
                        <a data-toggle="tooltip" data-placement="bottom" title="Fully Paid" *ngIf="l.BillStatus=='FP'">

                          <i class="fas fa-circle color-green  nav-link-hand font-size-14">
                          </i>
                        </a>
                        <a data-toggle="tooltip" data-placement="bottom" title="Partially Paid" *ngIf="l.BillStatus=='PP'">

                          <i class="fas fa-circle color-Assign  nav-link-hand font-size-14">
                          </i>
                        </a>
                        <a data-toggle="tooltip" data-placement="bottom" title="Not Paid" *ngIf="l.BillStatus=='NP'">

                          <i class="fas fa-circle color-gray  nav-link-hand font-size-14">
                          </i>
                        </a>
                      </div>
                      <div class="text-align-center  margin-bottom-0px row-height-26px"><label class="font-size-12px">{{l.BillCreatedDate| date: 'hh:mm a'}}</label></div>

                      <div class="text-align-center margin-bottom-0px row-height-17px" *ngIf="l.BillType=='OPBILL'"><label class="font-size-12px margin-bottom-0px color-Assign font-weight-bold">OP</label></div>
                      <div class="text-align-center margin-bottom-0px row-height-17px" *ngIf="l.BillType=='OPADVC'"><label class="font-size-12px margin-bottom-0px color-Assign font-weight-bold">OPADVC</label></div>
                      <div class="text-align-center margin-bottom-0px row-height-17px" *ngIf="l.BillType=='IPADVC'"><label class="font-size-12px margin-bottom-0px color-Assign font-weight-bold">IP</label></div>
                      <div class="text-align-center margin-bottom-0px row-height-17px" *ngIf="l.BillType=='RXBILL'"><label class="font-size-12px margin-bottom-0px color-Assign font-weight-bold">RX</label></div>



                    </div>
                  </div>
                </div>
                <!--<div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                  <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                    <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                  </div>
                  <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                    <div class="row row-height-17px">
                      <div class="col-md-12">
                        <label class="margin-bottom-0px">Ramya santhosh</label>
                      </div>
                    </div>
                    <div class="row row-height-17px">
                      <div class="col-md-12">
                        <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                      </div>
                    </div>
                    <div class="row row-height-17px">
                      <div class="col-md-4">
                        <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-3 padding-left-0px margin-top-5px">
                    <div class="text-align-center">
                      <i class="fas fa-check-circle color-icon-completed "></i>
                    </div>
                    <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                  </div>
                </div>-->
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div class="columnbp4" *ngIf="billdetails1">
      <div class="col-md-12 padding-left-0px">
        <div class="card">
          <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px" id="header">
            <div class="row">

              <div class="col-md-1 " *ngIf="CurrentX_BillHeaderController">
                <img class=" margin-left-6px image-width-scans" [src]="CurrentX_BillHeaderController.PatientImageFile" onError="this.src='dummy.jpg';">
                <a class="style-hover" data-toggle="tooltip" data-placement="bottom" title="Fully Paid" *ngIf="CurrentX_BillHeaderController.BillStatus=='FP'">

                  <i class="fas fa-circle color-green nav-link-hand font-size-14">
                  </i>
                </a>
                <a class="style-hover" data-toggle="tooltip" data-placement="bottom" title="Partially Paid" *ngIf="CurrentX_BillHeaderController.BillStatus=='PP'">

                  <i class="fas fa-circle color-Assign nav-link-hand font-size-14">
                  </i>
                </a>
                <a class="style-hover" data-toggle="tooltip" data-placement="bottom" title="Not Paid" *ngIf="CurrentX_BillHeaderController.BillStatus=='NP'">

                  <i class="fas fa-circle color-gray nav-link-hand font-size-14">
                  </i>
                </a>
              </div>
              <div class="col-md-5 padding-left-23px">
                <div class="row row-height-17px margin-left-0px">
                  <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px" *ngIf="CurrentX_BillHeaderController">
                    <label class="margin-bottom-0px font-weight-normal color-secondary">{{CurrentX_BillHeaderController.PatientName}} </label>
                  </div>
                </div>

                <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
                  <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                    <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                  </div>
                </div>-->
                <div class="row row-height-17px">
                  <div class="col-md-12" *ngIf="CurrentX_BillHeaderController">
                    <label class="font-size-12px margin-bottom-0px font-weight-normal">{{CurrentX_BillHeaderController.PatientAgeY}}, {{CurrentX_BillHeaderController.PatientFormattedCode}}</label>
                  </div>
                </div>
                <div class="row row-height-17px">
                  <div class="col-md-4" *ngIf="CurrentX_BillHeaderController">
                    <label class="font-size-12px margin-bottom-0px font-weight-normal">{{CurrentX_BillHeaderController.PatientTelephoneNumber1}}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-5  padding-right-0px">
                <div class="row font-size-12px">
                  <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Bill No</label>
                  </div>:
                  <div class="col-md-5 padding-right-0px padding-left-10px" *ngIf="CurrentX_BillHeaderController">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px ">{{CurrentX_BillHeaderController.BillNo}}</label>
                  </div>
                </div>
                <div class="row font-size-12px">
                  <div class="col-md-6 margin-left-auto text-align-right padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Date &amp;Time </label>
                  </div>:
                  <div class="col-md-5 padding-right-0px padding-left-10px" *ngIf="CurrentX_BillHeaderController">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">{{CurrentX_BillHeaderController.BillCreatedDate | date:'MMM-dd-yyyy'}} {{CurrentX_BillHeaderController.BillCreatedDate| date: 'hh:mm a'}}</label>
                  </div>
                </div>
                <div class="row font-size-12px" *ngIf="BillData2">
                  <div class="col-md-6 margin-left-auto text-align-right padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Doctor </label>
                  </div>:
                  <div class="col-md-5 padding-right-0px padding-left-10px">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">{{BillData2.PrescriberName}}</label>
                  </div>
                </div>
                <!--<div class="row font-size-12px">
                  <div class="col-md-6 margin-left-auto text-align-right padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Total </label>
                  </div>:
                  <div class="col-md-5 padding-right-0px padding-left-10px" *ngIf="CurrentX_BillHeaderController">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">{{CurrentX_BillHeaderController.TotalAmount | number:'1.0-0' |removeComma}}</label>
                  </div>
                </div>
                <div class="row font-size-12px">
                  <div class="col-md-6 margin-left-auto text-align-right padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Paid </label>
                  </div>:
                  <div class="col-md-5 padding-right-0px padding-left-10px" *ngIf="CurrentX_BillHeaderController">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">{{CurrentX_BillHeaderController.PaidTotal}}</label>
                  </div>
                </div>
                <div class="row font-size-12px">
                  <div class="col-md-6 margin-left-auto text-align-right padding-right-10px ">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Due </label>
                  </div>:
                  <div class="col-md-5 padding-right-0px padding-left-10px" *ngIf="CurrentX_BillHeaderController">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">{{CurrentX_BillHeaderController.Balance}}</label>
                  </div>
                </div>-->
                <!--<div class="row">
                  <div class="col-md-1 margin-left-auto padding-left-7px">
                    <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
                    </div>
                  <div class="col-md-1 padding-left-7px">
                    <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
                  </div>

                   <div class="col-md-1 padding-left-7px">

                    <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
                  </div>

                </div>-->
                <!--<div class="row margin-right-0px">
                  <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                    <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
                  </div>
                  <div class="Dsa2" *ngIf="DSADetails">
                    <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
                  </div>
                  <div class="Dsa3" *ngIf="DSADetails">

                    <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
                  </div>

                </div>-->
              </div>
            </div>

          </div>
          <div class="card-body padding-right-0px padding-top-0px padding-bottom-0px padding-left-0px">

            <div class="card">
              <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                <div class="row nav-link-hand margin-right-0px" id="edit-link">
                  <div class="col-md-3 padding-right-0px">
                    <label class="margin-bottom-0px font-size-16px font-weight-normal padding-left-10px" *ngIf="CurrentX_BillHeaderController">
                      {{CurrentX_BillHeaderController.BillType}} Details
                    </label>
                  </div>
                  <!--<div class="col-md-7 text-align-right">

                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Total</label>:<label class="font-weight-normal font-size-12px margin-bottom-0px ">5000</label>,
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Paid</label>:<label class="font-weight-normal font-size-12px margin-bottom-0px "></label>,
                    <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">Due</label>:<label class="font-weight-normal font-size-12px margin-bottom-0px ">0</label>
                  </div>-->
                  <div class="col-md-9  padding-right-3px">
                    <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                    <div class="row float-right" *ngIf="CurrentX_BillHeaderController">

                      <!--<div class="col-md-1 margin-top-3px padding-right-10px">
                        <button type="button" (click)="opbill()" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Save"><i class="fas fa-pencil-alt"></i></button>


                      </div>-->


                      <div class="col-md-12 margin-top-3px padding-left-0px padding-right-0px text-align-right" *ngIf="CurrentX_BillHeaderController">
                        <div class="display-inline" *canUserAccess="['HL_BL_9']">
                          <button type="button" (click)="billedit()" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Edit" *ngIf="CurrentX_BillHeaderController.BillStatus=='NP' || CurrentX_BillHeaderController.BillStatus=='PP'  && CurrentX_BillHeaderController.BillType=='OPBILL' "><i class="fas fa-pencil-alt"></i></button>
                        </div>
                        <div class="display-inline" *canUserAccess="['HL_BL_31']">
                          <button type="button" (click)="billeditSvcProvider()" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Edit" *ngIf="CurrentX_BillHeaderController.BillStatus=='NP' || CurrentX_BillHeaderController.BillStatus=='PP'  && CurrentX_BillHeaderController.BillType=='OPBILL' "><i class="fas fa-pencil-alt"></i></button>
                        </div>
                        <div class="display-inline" *canUserAccess="['HL_BL_18']">
                          <button type="button" class="btn btn-secondary font-size-13px margin-right-3px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="Cancel()">
                            <i class="fa fa-times color-Rejected nav-link-hand margin-right-3px"></i>Remove Bill
                          </button>
                        </div>
                        <div class="display-inline" *canUserAccess="['HL_BL_26']">
                          <button type="button" class="btn btn-secondary font-size-13px margin-right-3px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="Cancel3()">
                            <i class="fa fa-times color-Rejected nav-link-hand margin-right-3px"></i>Remove Bill
                          </button>
                        </div>
                        <div class="display-inline" *canUserAccess="['HL_BL_OP_ChangeDate']">
                          <button type="button" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="ChangeDate()">
                            Change Date
                          </button>
                        </div>
                        <div class="display-inline" *canUserAccess="['HL_BL_Gen_LabOrder']">
                          <button type="button" *ngIf="CurrentX_BillHeaderController.BillStatus=='FP'"
                                  class="btn btn-secondary font-size-13px margin-right-3px btn-raised button-Schedule actions-btn-prime actions-btn-prime3"
                                  (click)="GenerateLabOrder()">
                            Generate Lab Order
                          </button>
                        </div>


                        <!--<a class="nav-link-hand education-navlink data-color-new" (click)="opbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillStatus=='FP'||'PP'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
  </a>-->
                        <!--<div *ngFor="let l of pdata"></div>-->
                        <div class="display-inline" *canUserAccess="['HL_BL_11']">
                          <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="opbill()" *ngIf="CurrentX_BillHeaderController.BillType=='OPBILL'">
                            <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A4
                          </button>
                        </div>
                        <div class="display-inline" *canUserAccess="['A5OPPrintWithoutSvcProvider']">
                          <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="A5opbill()" *ngIf="CurrentX_BillHeaderController.BillType=='OPBILL'">
                            <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A5
                          </button>
                        </div>
                        <div class="display-inline" *canUserAccess="['HL_BL_32']">
                          <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="opbillSvc_Provider()" *ngIf="CurrentX_BillHeaderController.BillType=='OPBILL'">
                            <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A4
                          </button>
                        </div>
                        <div class="display-inline" *canUserAccess="['A5OPPrintWithSvcProvider']">
                          <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="A5opbillSvc_Provider()" *ngIf="CurrentX_BillHeaderController.BillType=='OPBILL'">
                            <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A5
                          </button>
                        </div>

                        <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="ipadvbill()" *ngIf="CurrentX_BillHeaderController.BillType=='IPADVC'">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A4
                        </button>
                        <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="A5ipadvbill()" *ngIf="CurrentX_BillHeaderController.BillType=='IPADVC'">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A5
                        </button>
                        <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="opadvbill()" *ngIf="CurrentX_BillHeaderController.BillType=='OPADVC'">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A4
                        </button>
                        <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="A5opadvbill()" *ngIf="CurrentX_BillHeaderController.BillType=='OPADVC'">
                          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A5
                        </button>
                        <div class="display-inline" *canUserAccess="['HL_BL_16']">
                          <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="rxbill()" *ngIf="CurrentX_BillHeaderController.BillType=='RXBILL'">
                            <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A4
                          </button>
                        </div>
                        <div class="display-inline" *canUserAccess="['HL_BL_16']">
                          <button type="submit" class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-5px" (click)="A5rxbill()" *ngIf="CurrentX_BillHeaderController.BillType=='RXBILL'">
                            <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> A5
                          </button>
                        </div>

                        <!--<a class="nav-link-hand education-navlink data-color-new" (click)="opbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='OPBILL'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px">A4<i class="fa fa-print"></i></span>
  </a>
  <a class="nav-link-hand education-navlink data-color-new" (click)="A5opbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='OPBILL'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px">A5<i class="fa fa-print"></i></span>
  </a>
  <a class="nav-link-hand education-navlink data-color-new" (click)="ipadvbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='IPADVC'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px">A4<i class="fa fa-print"></i></span>
  </a>
  <a class="nav-link-hand education-navlink data-color-new" (click)="A5ipadvbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='IPADVC'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px">A5<i class="fa fa-print"></i></span>
  </a>
  <a class="nav-link-hand education-navlink data-color-new" (click)="opadvbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='OPADVC'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px">A4<i class="fa fa-print"></i></span>
  </a>
  <a class="nav-link-hand education-navlink data-color-new" (click)="A5opadvbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='OPADVC'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px">A5<i class="fa fa-print"></i></span>
  </a>
  <a class="nav-link-hand education-navlink data-color-new" (click)="rxbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='RXBILL'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px">A4<i class="fa fa-print"></i></span>
  </a>
  <a class="nav-link-hand education-navlink data-color-new" (click)="A5rxbill()" title="print" *ngIf="CurrentX_BillHeaderController.BillType=='RXBILL'">
    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px">A5<i class="fa fa-print"></i></span>
  </a>-->
                      </div>

                    </div>




                  </div>

                </div>
              </div>
              <div class=" padding-lrt " data-ps-id="dfsfsde">
                <div class="card-body">
                  <div id="items">
                    <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                      <div class="accordion" id="accordionExampleone">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                            <div class="row">
                              <div class="col-md-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Services
                                  </button>
                                </h5>
                              </div>

                            </div>


                          </div>

                          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExampleone">
                            <div *canUserAccess="['HL_BL_33']" class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="table-component">
                                    <div class="table-responsive overflow-x">


                                      <table class="table table-striped"
                                             cols="auto,2*,*,*,*,*,*,*">

                                        <thead class="">
                                          <tr>

                                            <th class="min-width-24px padding-bottom-4px padding-top-4px">
                                              #
                                            </th>
                                            <th class="padding-top-4px padding-bottom-4px">
                                              Service Description
                                            </th>
                                            <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                                              QTY
                                            </th>
                                            <th class="text-align-right padding-right-0px padding-top-4px padding-bottom-4px">
                                              Unit Price
                                            </th>
                                            <th class="text-align-right padding-right-0px padding-top-4px padding-bottom-4px">
                                              Item Total
                                            </th>
                                            <th class="text-align-right padding-right-0px padding-top-4px padding-bottom-4px" *ngIf="DiscountMode=='Item Level'">
                                              Disc %
                                            </th>

                                            <th class="text-align-right padding-top-4px padding-bottom-4px" *ngIf="DiscountMode=='Item Level'">
                                              Net
                                            </th>
                                            <th class="text-align-center padding-top-4px padding-bottom-4px padding-right-6px" *ngIf="DiscountMode=='Bill Level'">
                                              Net
                                            </th>
       
                                          </tr>
                                        </thead>

                                        <tbody class="table-body">
                                          <tr *ngFor="let l of CurrentX_BillItemsController;let RowIndex = index">


                                            <td class="td-padding-tb">

                                              {{RowIndex+1}}
                                            </td>
                                            <td class=" td-padding-tb">
                                              {{l.ItemDescription}}
                                            </td>
                                            <td class="text-align-center td-padding-tb padding-right-0px">{{l.Quantity}}</td>
                                            <td class="text-align-right td-padding-tb  padding-right-7px">{{l.UnitPrice | number:'1.0-0' |removeComma}}</td>
                                            <td class="td-padding-tb text-align-right padding-right-7px">{{l.ItemTotal | number:'1.0-0' |removeComma}}</td>
                                            <td class="td-padding-tb text-align-right  padding-left-0px" *ngIf="DiscountMode=='Item Level'">{{l.Discount | number:'1.0' |removeComma}}</td>

                                            <td class="td-padding-tb text-align-right  padding-left-0px">{{(l.Quantity * l.UnitPrice)-(l.Quantity * l.UnitPrice * (l.Discount / 100)) | number:'1.0-0' |removeComma}}</td>



                                          </tr>

                                        </tbody>



                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>



                            </div>

                            <div *canUserAccess="['HL_BL_34']" class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="table-component">
                                    <div class="table-responsive overflow-x">


                                      <table class="table table-striped"
                                             cols="auto,2*,*,*,*,*,*,*">

                                        <thead class="">
                                          <tr>

                                            <th class="min-width-24px padding-bottom-4px padding-top-4px">
                                              #
                                            </th>


                                            <th class="padding-top-4px padding-bottom-4px">
                                              Service Description
                                            </th>
                                            <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                                              QTY
                                            </th>
                                            <th class="text-align-right padding-right-0px padding-top-4px padding-bottom-4px">
                                              Unit Price
                                            </th>
                                            <th class="text-align-right padding-right-0px padding-top-4px padding-bottom-4px">
                                              Item Total
                                            </th>




                                            <th class="text-align-right padding-right-0px padding-top-4px padding-bottom-4px" *ngIf="DiscountMode=='Item Level'">
                                              Disc %
                                            </th>

                                            <th class="text-align-right padding-top-4px padding-bottom-4px" *ngIf="DiscountMode=='Item Level'">
                                              Net
                                            </th>
                                            <th class="text-align-center padding-top-4px padding-bottom-4px padding-right-6px" *ngIf="DiscountMode=='Bill Level'">
                                              Net
                                            </th>
                                            <!--<th class="">

                  </th>-->







                                          </tr>
                                        </thead>

                                        <tbody class="table-body">
                                          <tr *ngFor="let l of CurrentX_BillItemsByProviderCodeController;let RowIndex = index">


                                            <td class="td-padding-tb">

                                              {{RowIndex+1}}
                                            </td>
                                            <td class=" td-padding-tb">

                                              <div class="row margin-left-0px">
                                                <div class="margin-right-3px">
                                                  <label class="margin-bottom-0px">{{l.ItemDescription}}</label>
                                                </div>
                                              </div>
                                              <div class="row margin-left-0px" *ngIf="l.ProviderCode!=0">
                                                <div class="margin-right-3px">
                                                  <label class="margin-bottom-0px font-size-12px font-weight-bold color-blue">{{l.ProviderName}}</label>
                                                </div>
                                              </div>
                                            </td>

                                            <td class="text-align-center td-padding-tb padding-right-0px">{{l.Quantity}}</td>
                                            <td class="text-align-right td-padding-tb  padding-right-7px">{{l.UnitPrice | number:'1.0-0' |removeComma}}</td>
                                            <td class="td-padding-tb text-align-right padding-right-7px">{{l.ItemTotal | number:'1.0-0' |removeComma}}</td>
                                            <td class="td-padding-tb text-align-right  padding-left-0px" *ngIf="DiscountMode=='Item Level'">{{l.Discount | number:'1.0' |removeComma}}</td>

                                            <td class="td-padding-tb text-align-right  padding-left-0px">{{(l.Quantity * l.UnitPrice)-(l.Quantity * l.UnitPrice * (l.Discount / 100)) | number:'1.0-0' |removeComma}}</td>



                                          </tr>

                                        </tbody>



                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>



                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div id="Receipts">
                    <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                      <div class="accordion" id="accordionExampleTwo">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                            <div class="row">
                              <div class="col-md-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                    Receipts
                                  </button>
                                </h5>
                              </div>

                            </div>


                          </div>

                          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExampleTwo">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="table-component">
                                    <div class="table-responsive overflow-x">


                                      <table class="table table-striped"
                                             cols="auto,2*,*,*,*,*,*,*">

                                        <thead class="">
                                          <tr>

                                            <th class="min-width-24px padding-top-4px padding-bottom-4px">
                                              #
                                            </th>


                                            <th class="padding-top-4px padding-bottom-4px">
                                              Date
                                            </th>
                                            <th class="text-align-left padding-left-0px padding-top-4px padding-bottom-4px">
                                              Receipt No
                                            </th>
                                            <th class="text-align-left padding-top-4px padding-bottom-4px">
                                              Payment Mode
                                            </th>
                                            <th class="text-align-right padding-top-4px padding-bottom-4px">
                                              Amount
                                            </th>

                                            <th class="text-align-left padding-top-4px padding-bottom-4px">
                                              Details
                                            </th>

                                            <th></th>






                                          </tr>
                                        </thead>

                                        <tbody class="table-body">
                                          <tr *ngFor="let l of CurrentX_BillReceiptsController;let RowIndex = index">


                                            <td class="td-padding-tb">

                                              {{RowIndex+1}}
                                            </td>
                                            <td class=" td-padding-tb">{{l.ReceiptDate | date:'MMM-dd-yyyy'}}</td>

                                            <td class="text-align-left padding-left-0px td-padding-tb">{{l.FormattedCode}}</td>
                                            <td class="text-align-left td-padding-tb ">{{l.PaymentInstrument}}</td>
                                            <td class="text-align-right td-padding-tb">{{l.ReceivedAmount | number:'1.0-0' |removeComma}}</td>

                                            <td class="td-padding-tb text-align-center">{{l.Remarks}}</td>

                                            <td class="td-padding-tb">
                                              <a *canUserAccess="['HL_BL_17']" (click)="EditReceipt(l)" class="nav-link-hand education-navlink" tooltip="Edit">
                                                <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                              </a>
                                              <a *canUserAccess="['HL_BL_17']" (click)="EditReceipt(l)" class="nav-link-hand font-size-16px color-Rejected"
                                                 title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>
                                            </td>


                                          </tr>

                                        </tbody>



                                      </table>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>


                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="columnbp3 background-white" *ngIf="billdetails2">

      <div class="position-fixed-Activities3">
        <div class="card">
          <div class="card-header border-left-clinical font-size-16px border-top-1px border-right-1px border-bottom-1px border-radius-5px wh-header padding-top-3px padding-bottom-3px padding-right-0px padding-left-9px">
            Bill Information
          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px margin-left-0px">
            <div class=" margin-top-5px border-bottom-8px-document">
              <div class="row font-weight-700 margin-left-0px margin-right-0px">
                <!--<div class="col-md-4 text-align-right padding-right-7px">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px white-space-pre">Patient Name</label>
                </div>:-->
                <div class="col-md-9 font-size-12px font-weight-normal padding-right-0px" *ngIf="PatientName">
                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px color-Assign">{{PatientName}}</label>

                </div>
              </div>
              <div class="row font-weight-700">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px">Bill Date  </label>
                </div>:
                <div class="col-md-7 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">

                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentX_BillHeaderController.BillCreatedDate | date:'MMM-dd-yyyy'}} {{CurrentX_BillHeaderController.BillCreatedDate| date: 'hh:mm a'}}</label>
                </div>
              </div>

              <div class="row font-weight-700">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px">Branch  </label>
                </div>:
                <div class="col-md-7 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">

                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentX_BillHeaderController.BranchName}}</label>
                </div>
              </div>
              <div class="row font-weight-700">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px">Bill By</label>
                </div>:
                <div class="col-md-7 padding-right-0px font-size-12px margin-top-3px font-weight-normal" *ngIf="CurrentX_BillHeaderController">
                  <label class="font-size-14 font-weight-normal margin-bottom-0px">{{CurrentX_BillHeaderController.PayeeName}}</label>

                </div>
              </div>
              <div class="row font-weight-700">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px"> Total Bill </label>
                </div>:
                <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">

                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentX_BillHeaderController.TotalAmount | number:'1.0' |removeComma}}</label>
                </div>
              </div>
              <div class="row font-weight-700">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px"> Discount </label>
                </div>:
                <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">

                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentX_BillHeaderController.Discount | number:'1.0' |removeComma}}</label>
                </div>
              </div>
              <div class="row font-weight-700">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px"> Net  </label>
                </div>:
                <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">

                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentX_BillHeaderController.Net | number:'1.0' |removeComma}}</label>
                </div>
              </div>
              <div class="row font-weight-700">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px"> Paid  </label>
                </div>:
                <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="CurrentX_BillHeaderController">

                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentX_BillHeaderController.Paid | number:'1.0' |removeComma}}</label>
                </div>
              </div>
              <div class="row font-weight-700" *ngIf="CurrentX_BillHeaderController && (CurrentX_BillHeaderController.BillType=='OPBILL' || CurrentX_BillHeaderController.BillType=='RXBILL')">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px"> Due  </label>
                </div>:
                <div class="col-md-5 font-size-12px font-weight-normal">

                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{CurrentX_BillHeaderController.Balance| number:'1.0' |removeComma}}</label>
                </div>
              </div>
              <!--<div class="row font-weight-700">
                <div class="col-md-4 text-align-right">
                  <label class="font-size-12px font-weight-normal margin-bottom-0px"> Paid Bill </label>
                </div>:
                <div class="col-md-5 font-size-12px font-weight-normal" *ngIf="PaidBill">

                  <label class="font-size-12px margin-top-5px font-weight-normal margin-bottom-0px">{{PaidBill | number:'1.0-0' |removeComma}}</label>
                </div>
              </div>-->
            </div>

            <div class="accordion" id="accordionExampleSections">
              <div class="card margin-bottom-5px">
                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSection">
                  <div class="row">
                    <div class="col-md-5">
                      <h5 class="mb-0 height-24px">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSection" aria-expanded="true" aria-controls="collapseSection">
                          Billing Sections
                        </button>
                      </h5>
                    </div>

                  </div>


                </div>

                <div id="collapseSection" class="collapse show" aria-labelledby="headingSection" data-parent="#accordionExampleSection">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                    <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                      <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="header()">Bill Header</a>
                      <!--<label> {{p.Title}}</label>-->



                    </div>
                    <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                      <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="items()">Services</a>
                      <!--<label> {{p.Title}}</label>-->



                    </div>
                    <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                      <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="Receipts()">Advances</a>
                      <!--<label> {{p.Title}}</label>-->



                    </div>


                    <div class="row card margin-left-0px margin-right-0px margin-bottom-5px">
                      <a class="nav-link-hand margin-left-10px margin-top-5px  font-size-12px font-weight-bold" (click)="Receipts()">Receipts</a>
                      <!--<label> {{p.Title}}</label>-->



                    </div>


                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>

      <!--<div class="card height-100vh">

        <div class="row">
          <div class="col-md-12">
            <h5 class="mb-0 height-24px">
              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                Bill Header
              </button>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h5 class="mb-0 height-24px">
              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                Services
              </button>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h5 class="mb-0 height-24px">
              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                Receipts
              </button>
            </h5>
          </div>
        </div>
      </div>-->



    </div>


  </div>
</div>
<!--<div class="col-md-12">

  <profileview [FormattedCode]="SelectedPatient.FormattedCode" [DisplayName]="SelectedPatient.DisplayName" *ngIf="ShowPatientDetails"></profileview>
</div>-->
